/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Magiclinkdesc2Inputs */

const zh_auth_magiclinkdesc2 = /** @type {(inputs: Auth_Magiclinkdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入您的邮箱地址，我们将发送一封登录链接邮件。`)
};

const en_auth_magiclinkdesc2 = /** @type {(inputs: Auth_Magiclinkdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email and we'll send you a magic link to sign in.`)
};

const es_auth_magiclinkdesc2 = /** @type {(inputs: Auth_Magiclinkdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu correo y te enviaremos un enlace mágico para iniciar sesión.`)
};

/**
* | output |
* | --- |
* | "Enter your email and we'll send you a magic link to sign in." |
*
* @param {Auth_Magiclinkdesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_magiclinkdesc2 = /** @type {((inputs?: Auth_Magiclinkdesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Magiclinkdesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_magiclinkdesc2(inputs)
	if (locale === "en") return en_auth_magiclinkdesc2(inputs)
	return es_auth_magiclinkdesc2(inputs)
});
export { auth_magiclinkdesc2 as "auth_magicLinkDesc" }